import { Navigate } from 'react-router-dom';

import { UserRole } from './AuthContext';
import { useAuth } from './useAuth';

const ROLE_HIERARCHY: UserRole[] = ['public', 'developer', 'admin'];

interface Props {
  minimumRole: UserRole;
  children: React.ReactNode;
}

export function ProtectedRoute({ minimumRole, children }: Props) {
  const { role, loading } = useAuth();

  if (loading) {
    return null;
  }

  if (ROLE_HIERARCHY.indexOf(role) < ROLE_HIERARCHY.indexOf(minimumRole)) {
    return <Navigate replace={true} to="/login" />;
  }

  return <>{children}</>;
}
